import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { buildAssetUrl } from "utils/Assets";
import classNames from "classnames";

import { setActiveVariable } from "reducers/Refinements";

import "./Thumbnail.css";

export default function Thumbnail(props) {
	const {
			variableInfo,
			isSelected = false,
			libraryId,
			className = "",
		} = props
		, dispatch = useDispatch()
		, assetUrl = variableInfo.assetUrl ?? buildAssetUrl(libraryId, variableInfo.data);

	const setSelectedVariable = useCallback(() => {
		dispatch(setActiveVariable(variableInfo.name));
	}, [dispatch, variableInfo.name]);

	return (<div className={classNames(className, "refinement-thumbnail", { selected: isSelected })}
		onClick={setSelectedVariable}>
		<div className="image-frame">
			<img src={assetUrl} alt={variableInfo.name} />
		</div>
		<div className="thumbnail-variable-name" title={variableInfo.name}>{variableInfo.name}</div>
		<div className="thumbnail-image-name" title={variableInfo.data}>{variableInfo.data}</div>
	</div>);
}

Thumbnail.displayName = "Thumbnail";
Thumbnail.propTypes = {
	variableInfo: PropTypes.shape({
		name: PropTypes.string,
		data: PropTypes.string,
		libraryId: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.string,
		]),
	}).isRequired,
	isSelected: PropTypes.bool,
};
